import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-email",
  "use": "icon-icon-email-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol viewBox=\"0 0 15 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-email\">\r\n<path d=\"M13.5 0H1.5C0.675 0 0.00749999 0.61875 0.00749999 1.375L0 9.625C0 10.3813 0.675 11 1.5 11H13.5C14.325 11 15 10.3813 15 9.625V1.375C15 0.61875 14.325 0 13.5 0ZM13.5 2.75L7.5 6.1875L1.5 2.75V1.375L7.5 4.8125L13.5 1.375V2.75Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol